import classnames from 'classnames'

const BUTTON_ROUNDED_STYLES =
  'h-[32px] rounded-full w-full sm:min-w-[120px] sm:w-auto mt-2 bg-surface hover:bg-surface-2 disabled:opacity-30 jost text-[0.9em] text-text border border-border'
interface IProps {
  form?: string
  type: 'button' | 'submit'
  loading: boolean
  text: string
  icon?: any
  className?: string
  callback?: () => void
}

export const ButtonRounded = ({ form, type, loading, text, icon, className, callback }: IProps) =>
  type === 'submit' ? (
    <button form={form} className={classnames(BUTTON_ROUNDED_STYLES, className)} type='submit' disabled={loading}>
      {text}
    </button>
  ) : (
    <button
      className={classnames(BUTTON_ROUNDED_STYLES, className)}
      type='button'
      disabled={loading}
      onClick={() => {
        if (callback) {
          callback()
        }
      }}
    >
      {icon && <span>{icon}</span>}
      {text}
    </button>
  )
